export default __webpack_public_path__ + "static/postgres-6ee7aced0f11d8fad7e7213c04a830d3.png";